jQuery(document).ready(function ($) {

  /* -----------------------
     TABS
  ----------------------- */

  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide().css('opacity', 0);
  $('.tab-content:first').show().css('opacity', 1);

  /* -----------------------
     SWIPER INSTANCES
  ----------------------- */

  let sellerSwiper = null;
  let relatedSwiper = null;

  /* -----------------------
     SELLER SWIPER (TAB)
  ----------------------- */
  function initSellerSwiper() {
    if (typeof Swiper === 'undefined') return;
    if (!$('.seller-slider').length || sellerSwiper) return;

    sellerSwiper = new Swiper('.seller-slider', {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.seller-pagination',
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 }
      }
    });
  }

  /* -----------------------
     RELATED SWIPER (OUTSIDE TABS)
  ----------------------- */
  function initRelatedSwiper() {
    if (typeof Swiper === 'undefined') return;
    if (!$('.related-slider').length || relatedSwiper) return;

    relatedSwiper = new Swiper('.related-slider', {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.related-next',
        prevEl: '.related-prev',
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 }
      }
    });
  }

  /* -----------------------
     INIT
  ----------------------- */
  initSellerSwiper();

  /* -----------------------
    OBSERVE SHOPIFY RELATED PRODUCTS LOAD
  ----------------------- */
  const relatedTarget = document.querySelector('.js-product-rec-wrapper');
  if (relatedTarget) {
    const relatedObserver = new MutationObserver(function () {
      if ($('.related-slider .swiper-slide').length) {
        initRelatedSwiper();
        relatedObserver.disconnect();
      }
    });
    relatedObserver.observe(relatedTarget, {
      childList: true,
      subtree: true
    });
  }

  /* -----------------------
     TAB CLICK
  ----------------------- */
  $('#tabs-nav li').on('click', function (e) {
    e.preventDefault();

    const activeTab = $(this).find('a').attr('href');
    if (!activeTab || !$(activeTab).length) return;

    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');

    $('.tab-content').stop(true, true).hide().css('opacity', 0);

    $(activeTab)
      .show()
      .animate({ opacity: 1 }, 400, function () {
        if (sellerSwiper) sellerSwiper.update();
      });
  });

});

//mattress logic 
(function () {

  function findRootByExactText(text) {
    const nodes = document.querySelectorAll('*');
    for (const node of nodes) {
      if (node.nodeType === 1 && node.textContent && node.textContent.trim() === text) {
        let parent = node.parentElement;
        while (parent && parent !== document.body) {
          if (parent.hasAttribute('data-unique')) return parent;
          parent = parent.parentElement;
        }
      }
    }
    return null;
  }

  function findRootByTitle(titleText) {
    const titles = document.querySelectorAll('.bcpo-title');
    for (const t of titles) {
      if (t.textContent.trim() === titleText) {
        let parent = t.parentElement;
        while (parent && parent !== document.body) {
          if (parent.hasAttribute('data-unique')) return parent;
          parent = parent.parentElement;
        }
      }
    }
    return null;
  }

  function getSelectedSize() {
    return document.querySelector('input[type="radio"][name="name0"]:checked');
  }

  function hide(el) {
    if (el) el.style.setProperty('display', 'none', 'important');
  }

  function show(el) {
    if (el) el.style.removeProperty('display');
  }

  function apply() {
    const size = getSelectedSize();
    if (!size) return;

    const hideAll = size.value === 'Queen' || size.value === 'King';

    const mattressStatus = findRootByTitle('Mattress Status:');
    const mattressThickness = findRootByTitle('Mattress Thickness:');

    const instructionText =
      '*We recommend a mattress up to 25 cm thick so the guard rails sit at the right height. If yours is thicker, no problem,  we’ll confirm the details after your order.';

    const instructionBlock = findRootByExactText(instructionText);

    if (hideAll) {
      hide(mattressStatus);
      hide(mattressThickness);
      hide(instructionBlock);
    } else {
      show(mattressStatus);
      show(mattressThickness);
      show(instructionBlock);
    }
  }

  document.addEventListener('change', e => {
    if (e.target.matches('input[type="radio"][name="name0"]')) {
      setTimeout(apply, 0);
    }
  });

  new MutationObserver(apply).observe(document.body, {
    childList: true,
    subtree: true
  });

  apply();

})();

jQuery(document).ready(function ($) {
  $('body.template-page-contact .content-wrapper').each(function () {
    const $wrapper = $(this);

    const $richText = $wrapper.find('section.rich__text-section').first();
    const $contactForm = $wrapper.find('section.contact-form').first();

    if ($richText.length && $contactForm.length) {
      const $richOuter = $richText.closest('.shopify-section');
      const $contactOuter = $contactForm.closest('.shopify-section');

      // Ensure same parent & correct order
      if (
        $richOuter.parent()[0] === $contactOuter.parent()[0] &&
        $richOuter.next()[0] === $contactOuter[0]
      ) {
        $richOuter.add($contactOuter).wrapAll(
          '<div class="custom-two-column-content"></div>'
        );
      }
    }
  });
});


